let routes = [
    {
      path: '/modification-formation-reconnue',
      component: () => import('../views/ModificationFormationReconnue.vue'),
      props: true
    },
    {
      path: '/modification-formation-reconnue/:step',
      component: () => import('../views/ModificationFormationReconnue.vue'),
      props: true
    }
  ]
  
  export default routes;